import { render } from "./Placeholder.vue?vue&type=template&id=46ae5216"
const script = {}
script.render = render

export default script